// src/hooks/useQuestionario.js
import { useState, useCallback } from 'react';
import QuestionarioService from '../services/QuestionarioService/QuestionarioService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useQuestionario = () => {
    const [questionario, setQuestionario] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    /**
     * Carica il questionario dal backend
     */
    const getQuestionario = useCallback(async (codice) => {
        setIsLoading(true);
        try {
            const data = await QuestionarioService.getQuestionario(codice);
            // Raggruppa le domande per sezione
            const sezioni = {};
            data.domande.forEach(q => {
                const sezione = q.sezione || 'Generale';
                if (!sezioni[sezione]) {
                    sezioni[sezione] = [];
                }
                sezioni[sezione].push(q);
            });
            // Salva sia i dati del questionario sia le sezioni raggruppate
            setQuestionario({ ...data, sezioni });
            return { ...data, sezioni };
        } catch (error) {
            handleError(error, "Errore nel caricamento del questionario");
            setQuestionario(null);
        } finally {
            setIsLoading(false);
        }
    }, []);

    /**
     * Salva le risposte del questionario
     */
    const salvaRisposte = useCallback(async (payload) => {
        setIsSubmitting(true);
        try {
            await QuestionarioService.salvaRisposte(payload);
            alertService.success("Questionario inviato con successo. Grazie!", { autoClose: true });
            return true; // Ritorna successo
        } catch (error) {
            handleError(error, "Errore nell'invio del questionario");
            return false; // Ritorna fallimento
        } finally {
            setIsSubmitting(false);
        }
    }, []);

    return {
        questionario,
        isLoading,
        isSubmitting,
        getQuestionario,
        salvaRisposte
    };
};

export default useQuestionario;